import React, { Component } from 'react';
import Header from '../../Common/Component/Header';
import Sidebar from '../../Common/Component/Sidebar';
import OperationMgrDashboard from './OperationMgrDashboard';
import FranchiseDashboard from './FranchiseDashboard';

class Dashboard extends Component {
  state = {
    current: ''
  }

  componentDidMount = () => {
    const authUser = JSON.parse(localStorage.getItem('authUser'))
    let current = 0;
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)
    if (logged_in_user_role?.includes('franchise_owner')) current = 1
    else if (logged_in_user_role?.includes('operations_mgr')) current = 0
    this.setState({current})
  }

  renderDashboard = () => {
    let { current } = this.state;
    switch (current) {
    case 0:
      return <OperationMgrDashboard {...this.props} />
    case 1:
      return <FranchiseDashboard {...this.props} />
    default:
      return <OperationMgrDashboard {...this.props} />
    }
  }

  render() {
    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header />
          {/* Sidebar */}
          <Sidebar history={this.props.history} />

          <div className="dashcontainer">
            <div className="">
              {this.renderDashboard()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Dashboard;